import {useEffect,useState} from 'react';

const useScreenSize = (breakpoint) => {
    const [width, setWidth] = useState(window.innerWidth);

    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    let isSmaller = (width <= breakpoint);
    return {isSmaller}
};

export default useScreenSize;